export const JOB_OFFER_PATH = "/job-offers/:jobOfferId";
